import React, { useState } from 'react'
import style from './style.module.sass'
import { useTheme } from '@material-ui/core/styles'
import config from '../../../../config'
import Filter from './Filter'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import ComBotGreen from "../../../../assets/combot-green.svg"
import ComBotGrey from "../../../../assets/combot-grey.svg"
import ComBotBlack from "../../../../assets/combot-black.svg"
import ComBotWhite from "../../../../assets/combot-white.svg"
import { Edit } from '@material-ui/icons'
import WbIncandescentIcon from "@material-ui/icons/WbIncandescent"
import { checkAiText } from '../../../../utils'
import { Redirect } from 'react-router-dom'

export default function Accordion ({
  handleModalAccordionOpen,
  handleTopAccordionOpen,
  handleOnPopupClick,
  getNextPopup
}) {

  const { theme: { bgColors, colors } } = useTheme()
  const { t } = useTranslation()
  const [redirect, setRedirect] = useState("")
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const resultData = useSelector(state => state.analyseData.result.resultData)
  const result = useSelector(state => state.analyseData.result)
  const filter = useSelector(state => state.analyseData.filter)
  const accordionItemsWithCells = useSelector(state => state.analyseData.accordionItemsWithCells)
  const text = useSelector((state) => state.analyseData.text)
  const aiMaxTextSize = useSelector((state) => state.userData?.user?.ai_settings?.max_text_size )
  const enabledSections = useSelector((state) => state.userData.user?.enabled_frontend_sections || [])
  const filterMessage = `analyse_green-button-info-${themeState}`
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const combotImage = themeState === config.THEMES_MODES.LIGHT ? ComBotGreen : (themeState === config.THEMES_MODES.CONTRAST_LIGHT ? ComBotBlack : ComBotWhite)
  const aiButtonEnable = checkAiText(text, aiMaxTextSize, 'Assistant')

  if (redirect) {
    return <Redirect to={redirect} />
  }
  return (
    <div className={`${style.mainCont} pt-0`}>
      <div className={`${style.header} mb-4`}>
        <div className={style.headerContent}>
          <div className={style.headerFilter} style={{ backgroundColor: bgColors.bgPrimary0, minWidth: enabledSections.indexOf("double-interface") > -1 ? '74%' : '100%' }}>
            <Filter />
          </div>
          {enabledSections.indexOf("double-interface") > -1 && <div className={style.headerIcons} >
            <div className={style.headerIconWrapper} style={{ backgroundColor: bgColors.bgPrimary0, cursor: aiButtonEnable ? 'pointer' : 'default' }} onClick={aiButtonEnable ? () => setRedirect('/ainstein') : undefined} title={aiButtonEnable ? `${t('switch to ai mode')}` : `${t('ai_text_too_long')}`} tabIndex={aiButtonEnable ? config.tabIndexes.aiModeButton : -1}>
              <p className={style.headerIconTitle} style={{ color: isContrast ? colors.colorContrast : colors.colorMutedText }}>{t("optimization")}</p>
              <img
                src={aiButtonEnable ? combotImage : ComBotGrey}
                alt="ComLab AI Bot"
                width="68px"
                height="48px"
              />
              <Edit style={{ position: 'absolute',top: 23, right: 12, fontSize: 18, color: isContrast ? colors.colorContrast : colors.colorMutedText }} />
            </div>
            <div className={style.headerIconWrapper} style={{ backgroundColor: bgColors.bgPrimary0, cursor: 'pointer' }} onClick={() => setRedirect('/text-generation')} title={t('switch to generation mode')} tabIndex={config.tabIndexes.genModeButton}>
              <p className={style.headerIconTitle} style={{ color: isContrast ? colors.colorContrast : colors.colorMutedText }}>{t("generation")}</p>
              <img
                src={combotImage}
                alt="ComLab AI Bot"
                width="68px"
                height="48px"
              />
              <WbIncandescentIcon style={{ position: 'absolute',top: 25, right: 12, fontSize: 18, color: isContrast ? colors.colorContrast : colors.colorMutedText }} />
            </div>
          </div>}
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-access-key */}
      <div className={`${style.rows} p-2`} style={{ backgroundColor: bgColors.bgPrimary0 }}
           accessKey={config.accessKeys.cockpit} tabIndex={config.tabIndexes.cockpit}>
        {
          filter.red && filter.yellow && !filter.green && accordionItemsWithCells?.length <= 1 &&
          <div className={`p-2`}>
            <p style={{ color: colors.colorProgress100 }} dangerouslySetInnerHTML={{ __html: t(filterMessage) }}/>
          </div>
        }
        {Object.entries(config.accordions).map(([keyModal, valModal], index) => {
          const showedValues = valModal.filter(val => resultData[val] !== undefined)
          const resultShowedValues = valModal.filter(val => result[val] !== undefined)

          if (showedValues?.length || resultShowedValues?.length) {
            const Component = config.modalAccordionComponents[keyModal]
            return <Component
              showedValues={showedValues.concat(resultShowedValues)}
              key={keyModal}
              handleOnPopupClick={handleOnPopupClick}
              getNextPopup={getNextPopup}
              filter={filter}
              index={index}
              handleTopAccordionOpen={handleTopAccordionOpen}
              handleModalAccordionOpen={handleModalAccordionOpen}
            />
          }
          return null
        })}


      </div>
    </div>
  )
}
